export default __webpack_public_path__ + "static/media/GalanoGrotesque-SemiBold.fdfc9091.ttf";